export default __webpack_public_path__ + "static/media/jangwon_badge_4.4e3a6b7b.svg";